export default class MessageProvider {

    messages: any[] = [];
    setStateFunc;

    constructor(setStateFunc: ({}) => void) {
        this.setStateFunc = setStateFunc;
    }

    getMessages() {
        return this.messages;
    }

    clearMessages() {
        this.messages = [];
        this.setStateFunc({});
    }

    success(message: string) {
        this.clearMessages();
        this.messageCommon(message, 'success')
    }

    error(message: string) {
        this.clearMessages();
        this.messageCommon(message, 'danger')
    }

    messageCommon(text: string, type: string) {
        this.messages.push({ text, type });
        this.setStateFunc({});

    }

}
